<div class="with-floating-button">
    <div class="content">
        <page-header *ngIf="isDisplayed" [title]="'admin.comptabilite.exercicesPeriodes.title' | translate" [listeItems]="listeTabItems" [selectedIndex]="selectedIndex"></page-header>

        <router-outlet></router-outlet>
    </div>
</div>